<ion-content class="not-found">
  <div class="not-found__holder">
    <div class="not-found__holder__content">
      <h1 class="">{{ 'page.not_found.title' | translate }}</h1>
      <p>{{ 'page.not_found.desc' | translate }}</p>
      <button routerLink="/" routerDirection="back">
        {{ 'page.not_found.back' | translate }}
        <span
          class="icon"
          [inlineSVG]="'/assets/icons/card/arrow-right.svg'"
        ></span>
      </button>
    </div>
  </div>
</ion-content>
